import styles from 'features/referral/components/referral-form/ReferralForm.module.scss'
import { EmailShareButton, FacebookMessengerShareButton, WhatsappShareButton } from 'react-share'
import classNames from 'classnames'
import { ShareButtonProps } from 'features/referral/components/share-buttons/types'
import { useTranslation } from 'next-i18next/pages'
import { FACEBOOK_APP_ID } from 'constants/envs'
import dayjs from 'dayjs'
import { REFERRAL_AMOUNT_GIVE } from 'features/referral/Referral.constants'
import { Icon } from '@boltenergy-be/design-system'

const ShareButtons = ({ referralLink, activeAction }: ShareButtonProps) => {
  // I18N
  const { t } = useTranslation(['referral'])

  // Constants
  const amountGive = activeAction?.reduction || REFERRAL_AMOUNT_GIVE
  const share = {
    subject: activeAction?.sharing?.subject || t('referrer.share.title', { amountGive }),
    body:
      activeAction?.sharing?.body ||
      t('referrer.share.message', {
        endDate: activeAction ? dayjs(activeAction?.end).format('D MMMM') : '',
        amountGive
      })
  }

  return (
    <ul className={styles['share-buttons']}>
      <li>
        <EmailShareButton url={referralLink} subject={share.subject} body={share.body}>
          <span className={classNames(styles['share-btn'])}>
            <Icon name="envelope" color="currentColor" size={24} />
          </span>
        </EmailShareButton>
      </li>
      <li>
        <FacebookMessengerShareButton title={share.subject} appId={FACEBOOK_APP_ID} url={referralLink}>
          <span className={classNames(styles['share-btn'])}>
            <Icon name="messenger" color="currentColor" size={24} />
          </span>
        </FacebookMessengerShareButton>
      </li>
      <li>
        <WhatsappShareButton url={referralLink} message={share.subject}>
          <span className={classNames(styles['share-btn'])}>
            <Icon name="whatsappFill" color="currentColor" size={24} />
          </span>
        </WhatsappShareButton>
      </li>
    </ul>
  )
}

export default ShareButtons
